import 'moment/locale/id';

import _ from "lodash";
import moment from "moment";
import styled from "styled-components";
import Countdown from 'react-countdown';
import React, { Component } from "react";
import { Header } from "semantic-ui-react";

import { UserContext } from "../../context";
import BaseContentLayout from "../../layouts/BaseContent";
import logo_kopsurat from '../../assets/logo_kopsurat.png';

const ContainerCountdown = styled.div`
  text-align: center;
  margin-top: 2em;
  margin-bottom: 1em; 
  color: #2d2b8b;
`
const ContainerContentSurat = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
`
const ContainerWaiting = styled.div`
  width: 100%;
  height: 90%;
  display: flex; 
  justify-content: center; 
  align-items: center;
`
const ContainerSurat = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: .5cm;
  justify-content: center;
  min-width: 650px;
  overflow: auto;

  p{
    font-family : Times New Roman;
  }
`
const ContainerKopSurat = styled.div`
  font-family: Times New Roman; 
  display: grid;
  grid-gap: 2em;
  align-items: center;
  grid-template-columns: auto 1fr;

  .full {
    grid-column: span 2;
  }
`
const ContainerGridContent = styled.div`
  display: grid;
  font-family: Times New Roman;
  grid-template-columns: 1fr auto 4fr;
  grid-gap: .5em;
  row-gap: .12em;
  margin-top: 1em;
  margin-bottom: 1em;
`

const Wrapper = styled.div`
  padding: 1em;
  min-width: 650px;
  max-width: 650px;
  font-size: 1.2em;
`


const getTahunAjaran = (date = moment()) =>{
	const y = Number(date.year());
	const m = Number(date.month());

	const ta = [];
	if (m >= 6) {
		// Juli or more
		ta.push(y, y + 1);
	} else {
		ta.push(y - 1, y);
	}
	return ta.join('/');
}
class Kelulusan extends Component {
  render() {
    const { user, tanggal_kelulusan } = this.context
    const tingkat = _.get(user, "kelas_tingkat", "-")
    const kode = _.get(user, "kelas_kode", "-")
    const program = _.get(user, "kelas_program", "-")
    const nama = _.get(user, "nama", "-")
    const nis = _.get(user, "nis", "-")
    const nisn = _.get(user, "nisn", "-")
    
    const status = _.get(user, "status", false)

    const now = moment();
    const tanggal_pengumuman = moment(tanggal_kelulusan)
    const delta = tanggal_pengumuman.diff(now)
    return (
      <BaseContentLayout>
        <div>
          <Header as="h3">
            Pengumuman Kelulusan Tingkat {tingkat}
            <Header.Subheader>
              Tahun Pelajaran {getTahunAjaran()}
            </Header.Subheader>
          </Header>
        </div>
        <div/>
        <div style={{overflow: "auto"}}>
          {delta <= 0 && <ContainerSurat>
            <Wrapper>
              <ContainerKopSurat>
                <div><img src={logo_kopsurat} width="90" height="90" alt="Logo Jawa Tengah"/></div>
                <div>
                  <div>
                    <h4 style={{textAlign: "center", fontFamily: "Times New Roman" }}>
                      PEMERINTAH PROVINSI JAWA TENGAH <br />
                      DINAS PENDIDIKAN DAN KEBUDAYAAN <br />
                      SEKOLAH MENENGAH ATAS NEGERI 6 SURAKARTA
                    </h4>
                  </div>
                  <div style={{textAlign: "center", fontFamily: "Times New Roman", fontSize: "13px"}}><p><b>
                    Jalan Mr. Sartono Nomor. 30 Surakarta Kode Pos 57135 Telepon 0271-853209 <br />
                    Faksimile 0271-853209 Surat Elektronik info@sman6surakarta.sch.id
                  </b></p></div>
                </div>
              </ContainerKopSurat>
              <div><hr style={{ border: "none", height: "3px", color: "black", backgroundColor: "black", marginTop: "5px"}} /></div>
              <ContainerContentSurat>
                <h4 style={{textAlign: "center", fontFamily: "Times New Roman" }}>
                  SURAT KETERANGAN LULUS<br />
                  {program === "MIPA" && "PEMINATAN MATEMATIKA DAN ILMU PENGETAHUAN ALAM"}
                  {program === "IPS" && "PEMINATAN ILMU PENGETAHUAN SOSIAL"}
                  {program === "BAHASA" && "PEMINATAN BAHASA"}<br />
                  TAHUN PELAJARAN {getTahunAjaran()}
                </h4>
                <p style={{fontFamily: "Times New Roman", marginTop: "1em" }}>
                  Yang bertanda tangan di bawah ini, Kepala Sekolah Menengah Atas (SMA) Negeri 6 Surakarta, Kota Surakarta menerangkan bahwa:
                </p>
                <ContainerGridContent>
                  <div>Nama</div>
                  <div>:</div>
                  <div>{nama}</div>
                  <div>NIS/ NISN</div>
                  <div>:</div>
                  <div>{nis}/ {nisn}</div>
                  <div>Kelas</div>
                  <div>:</div>
                  <div>{kode}</div>
                  <div>Asal Sekolah</div>
                  <div>:</div>
                  <div>SMA Negeri 6 Surakarta</div>
                </ContainerGridContent>
                <div>
                  <p>
                    berdasarkan kriteria kelulusan peserta didik yang telah ditetapkan, maka yang bersangkutan dinyatakan:
                  </p>
                </div>
                <div style={{marginTop: "1em", marginBottom: "1em"}}>
                  <h2 style={{textAlign: "center", fontFamily: "Times New Roman" }}>
                    {status ? "LULUS" : "TIDAK LULUS"}
                  </h2>
                </div>
                <p>
                  Surat Keterangan Lulus (SKL) ini dapat digunakan untuk keperluan Penerimaan Mahasiswa
                  Baru (PMB) atau keperluan lain sesuai dengan kebutuhan, dan hanya berlaku sampai dengan
                  diterbitkannya ijazah.
                </p>
                <div style={{display: "flex", justifyContent: "flex-end", marginTop: "1em" }}>
                  <p style={{fontFamily: "Times New Roman"}}>
                    Surakarta, {moment(tanggal_pengumuman).format("DD MMMM YYYY")}<br />
                    Kepala Sekolah<br />
                    <span>
                      <div style={{ display: "flex", alignItems: "center", height: "80px"}}>
                        <p>(ttd)</p>
                      </div>
                    </span>
                    <span><u>Drs. Narman, MM</u></span><br />
                    NIP. 19641030 199501 1 001
                  </p>
                </div>
              </ContainerContentSurat>
            </Wrapper>
          </ContainerSurat>}
          {delta > 0 && <ContainerWaiting>
            <div>
              <div>
               <Header as="h3" style={{textAlign: "center"}}>
                  Mohon sabar menunggu. <br />
                  Hasil kelulusan akan diumumkan dalam waktu
                </Header>
              </div>
              <ContainerCountdown>
                <h1>
                  <Countdown onComplete={() => { window.location.reload() }} date={Date.now() + delta} />
                </h1>
              </ContainerCountdown>
              <div style={{textAlign: "center"}}>Hari : Jam : Menit : Detik</div>
            </div>
          </ContainerWaiting>}
        </div>
      </BaseContentLayout>
    );
  }
}

Kelulusan.contextType = UserContext
export default Kelulusan;